import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { get_dataset_url } from '@/utils/urls.ts';
import { DATASET_KEY } from '@/utils/queryKeys.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { SimpleResponse } from '@/types/common.ts';

type UpdateDatasetParams = {
  name: string;
};

const useUpdateDataset = (
  id?: string,
): UseMutationResult<SimpleResponse, AxiosError, UpdateDatasetParams> => {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: UpdateDatasetParams) => {
      const response = await apiClient.put(get_dataset_url(id), params);
      return response.data;
    },
    onSuccess: async (_) => {
      await queryClient.invalidateQueries({ queryKey: DATASET_KEY(id!) });
      // await queryClient.invalidateQueries({ queryKey: DATASET_KEY(id!, false) });
    },
  });
};

export default useUpdateDataset;
